export default angular.module('logout', []).config(($stateProvider) => {
	$stateProvider.state({
		name: 'logout',
		url: '/logout',
		controller: 'LogoutController'
	});
}).controller('LogoutController', function($scope, $state, userService, $timeout, carsService) {
	
	let appSettings = userService.getAppSettings();
	if (angular.isDefined(appSettings.rememberMe) && appSettings.rememberMe) {
		appSettings.introWizardDone = false;
		userService.setAppSettings(appSettings);
		$state.go('autovraky.home');
		$timeout(() => {
			location.reload(true);
		}, 1000);
		
	} else {
		carsService.purgeCars();
		if (localStorage.getItem('userSettings')) {
			localStorage.clear();
			$state.go('autovraky.home');
			$timeout(() => {
				location.reload(true);
			}, 1000);
		}
	}
}).name;



// WEBPACK FOOTER //
// build/modules/logout/logout.js